import React, { useContext } from "react";
import Helmet from "react-helmet";
import Layout from "../components/layouts/tarjetas";
import { graphql } from "gatsby";
import Beneficios from "../components/producto/beneficios";
import Calculadoras from "../components/producto/calculadoras";
import MasInfo from "../components/producto/mas-info";
import Hero from "../components/producto/heros";
import PanelConSwitch from "../components/producto/panel-con-switch";
import Box from "../components/box";
import { ProductContext } from "../components/producto/product-context";
import StickyCta from "../components/botones/sticky-cta";
import Marcas from "../components/producto/marcas";

const Template = ({
  data: {
    pagina: {calculadora, hero},
    producto,
    tasasDeInteres,
    multicanalidad: multicanalidadOriginal
  }
}) => {
  const { pais, titulo } = producto;
  const variaciones = producto.variacion
    .map((variacion, index) => {
      const beneficiosEspecificos = variacion.beneficiosEspecificos
        ? variacion.beneficiosEspecificos.map(b => b.titulo)
        : [];
      const beneficiosGenerales = producto.beneficiosGenerales.map(
        b => b.titulo
      );
      return {
        ...variacion,
        beneficios: [...beneficiosEspecificos, ...beneficiosGenerales],
        monedas: producto.monedas,
        planDeLealtad: producto.planDeLealtad,
        requisitos: producto.requisitos,
        terminosYCondiciones: producto.trminosYCondiciones,
        reglamento: producto.reglamento,
        selected: index === 0,
        producto: producto.titulo,
        tasasDeInteres: tasasDeInteres.edges
          .map(t => t.node)
          .find(t =>
            t.colores.map(c => c.titulo).includes(variacion.color.titulo)
          )
      };
    })
    .reduce(
      (unique, item) =>
        unique.find(q => q.color.titulo === item.color.titulo)
          ? unique
          : [...unique, item],
      []
    );
  const { selectedColorKey } = useContext(ProductContext) || 0;
  const selectedVariacion = variaciones[selectedColorKey];
  const colores = variaciones.map((variacion, i) => ({
    id: variacion.color.id,
    titulo: variacion.color.titulo,
    variacion: variacion.id,
    arte: variacion.arte,
    selected: i === selectedColorKey
  }));
  const multicanalidad = producto.formOpa
    ? { ...multicanalidadOriginal, form: producto.formOpa }
    : multicanalidadOriginal;

  const marcas = producto.variacion
    .map(p => p.emisor)
    .reduce(
      (arr, curr) =>
        !arr.find(m => m.nombre === curr.nombre) ? [...arr, curr] : arr,
      []
    );
  return (
    <Layout {...{ pais }}>
      <Helmet
        title={titulo}
        meta={[
          {
            name: "description",
            content: titulo
          }
        ]}
      />
      <Hero {...{ variaciones }} {...{ hero }} />
      <PanelConSwitch
        titulo="Beneficios"
        descripcion="Seleccioná un nivel para conocer sus detalles"
        {...{ variaciones }}
      >
        <Beneficios beneficios={selectedVariacion.beneficios} />
        <Marcas {...{ marcas }} />
      </PanelConSwitch>
      {calculadora && (
        <Box bg="grisDeFondo" py={[3, 6]} px={[2, 0]}>
          <Calculadoras producto={titulo} {...{ colores }} />
        </Box>
      )}
      <PanelConSwitch
        titulo="Más información"
        descripcion=""
        {...{ variaciones }}
      >
        <MasInfo producto={selectedVariacion} />
      </PanelConSwitch>
      <StickyCta multicanalidad={multicanalidad} />
    </Layout>
  );
};

export const query = graphql`
  query($id: String!, $pagId: String!) {
    producto: contentfulProducto(id: { eq: $id }) {
      titulo
      formOpa
      slug
      monedas
      beneficiosGenerales {
        titulo
      }
      variacion {
        id
        titulo
        limite
        emisor {
          nombre
          logo {
            file {
              url
            }
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
        color {
          id
          titulo
        }
        arte {
          file {
            url
          }
          fluid(maxWidth: 500) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        beneficiosEspecificos {
          titulo
        }
        tipoDeCosto
        monedaDeCosto
        costo
      }
      pais {
        title
        countrySlug
        contryAbr
      }
      planDeLealtad {
        titulo
        reglasDeAcumulacion {
          titulo
          reglas {
            childMarkdownRemark {
              html
            }
          }
          colores {
            titulo
          }
        }
        minimoDeRedencion
        metodoDeRedencion {
          childMarkdownRemark {
            html
          }
        }
        maximoDeAcumulacion
        vencimientoDePuntos
        costoDeRedencion
      }
      requisitos
      trminosYCondiciones
      reglamento
    }
    multicanalidad: contentfulMulticanalidadLinks(
      identificador: { eq: "multicanalidad-tarjetas-cr" }
    ) {
      formLlamada
      telefono
      whatsapp
      form
    }
    tasasDeInteres: allContentfulTasasDeInteres {
      edges {
        node {
          id
          titulo
          preferencialColones
          preferencialDolares
          normalColones
          normalDolares
          orden
          colores {
            titulo
          }
        }
      }
    }
    pagina: contentfulPaginaDeTarjeta(id: { eq: $pagId }) {
      calculadora
      hero {
        titular
        subTitular
        imagen {
          fluid(maxWidth: 500) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  }
`;

export default Template;
